import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/Card.css'

const Card = (props) => {
    return (
        <>
            <div className="card p-2 my-2 cardTarjeta">
                <img className="card-img-top" src={props.picturePath} alt="preview"/>
                <div className="card-body">
                    <h5 className="card-title">{props.brand}</h5>
                    <p className="card-text">{props.model} - {props.year}</p>
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between">
                    <small className="text-muted">{props.descrip}</small>
                    <Link to={"/detalleCarro/"+props._id} className="btn btn-danger mx-2">Detalles</Link>
                </div>
            </div>
        </>
        )
}

export default Card